var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('NavWithoutSidebar',{attrs:{"title":_vm.title}}),_c('v-content',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',[_vm._t("default")],2)],1)],1)],1),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }